import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'

export default function StackNLoadStar({ disabled }: { disabled?: boolean }): React.ReactElement {
  const { t } = useTranslation('games')
  return disabled ? (
    <SVGImage alt={t('cranegame.emptyStar')} className="h-5" srcKey="scoreboard/star-disabled.svg" />
  ) : (
    <SVGImage alt={t('cranegame.star')} className="h-5 mt-1" srcKey="scoreboard/star-enabled.svg" />
  )
}
